import Layout from "../components/Layout";

export default function Checkout(){
    return <Layout>
    {/* <!-- Page Title --> */}
    <div className="page-title light-background">
      <div className="container d-lg-flex justify-content-between align-items-center">
        <h1 className="mb-2 mb-lg-0">Checkout</h1>
        <nav className="breadcrumbs">
          <ol>
            <li><a href="index.html">Home</a></li>
            <li className="current">Checkout</li>
          </ol>
        </nav>
      </div>
    </div>{/* <!-- End Page Title --> */}

    {/* <!-- Checkout Section --> */}
    <section id="checkout" className="checkout section">

      <div className="container" data-aos="fade-up" data-aos-delay="100">

        <div className="row">
          <div className="col-lg-7">
            {/* <!-- Checkout Form --> */}
            <div className="checkout-container" data-aos="fade-up">
              <form className="checkout-form">
                {/* <!-- Customer Information --> */}
                <div className="checkout-section" id="customer-info">
                  <div className="section-header">
                    <div className="section-number">1</div>
                    <h3>Customer Information</h3>
                  </div>
                  <div className="section-content">
                    <div className="row">
                      <div className="col-md-6 form-group">
                        <label htmlFor="first-name">First Name</label>
                        <input type="text" name="first-name" className="form-control" id="first-name" placeholder="Your First Name" required="" />
                      </div>
                      <div className="col-md-6 form-group">
                        <label htmlFor="last-name">Last Name</label>
                        <input type="text" name="last-name" className="form-control" id="last-name" placeholder="Your Last Name" required="" />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email Address</label>
                      <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required="" />
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number</label>
                      <input type="tel" className="form-control" name="phone" id="phone" placeholder="Your Phone Number" required="" />
                    </div>
                  </div>
                </div>

                {/* <!-- Shipping Address --> */}
                <div className="checkout-section" id="shipping-address">
                  <div className="section-header">
                    <div className="section-number">2</div>
                    <h3>Shipping Address</h3>
                  </div>
                  <div className="section-content">
                    <div className="form-group">
                      <label htmlFor="address">Street Address</label>
                      <input type="text" className="form-control" name="address" id="address" placeholder="Street Address" required="" />
                    </div>
                    <div className="form-group">
                      <label htmlFor="apartment">Apartment, Suite, etc. (optional)</label>
                      <input type="text" className="form-control" name="apartment" id="apartment" placeholder="Apartment, Suite, Unit, etc." />
                    </div>
                    <div className="row">
                      <div className="col-md-4 form-group">
                        <label htmlFor="city">City</label>
                        <input type="text" name="city" className="form-control" id="city" placeholder="City" required="" />
                      </div>
                      <div className="col-md-4 form-group">
                        <label htmlFor="state">State</label>
                        <input type="text" name="state" className="form-control" id="state" placeholder="State" required="" />
                      </div>
                      <div className="col-md-4 form-group">
                        <label htmlFor="zip">ZIP Code</label>
                        <input type="text" name="zip" className="form-control" id="zip" placeholder="ZIP Code" required="" />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="country">Country</label>
                      <select className="form-select" id="country" name="country" required="">
                        <option _value="">Select Country</option>
                        <option _value="US">United States</option>
                        <option _value="CA">Canada</option>
                        <option _value="UK">United Kingdom</option>
                        <option _value="AU">Australia</option>
                        <option _value="DE">Germany</option>
                        <option _value="FR">France</option>
                      </select>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" id="save-address" name="save-address" />
                      <label className="form-check-label" htmlFor="save-address">
                        Save this address for future orders
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" id="billing-same" name="billing-same" _value="" />
                      <label className="form-check-label" htmlFor="billing-same">
                        Billing address same as shipping
                      </label>
                    </div>
                  </div>
                </div>

                {/* <!-- Payment Method --> */}
                <div className="checkout-section" id="payment-method">
                  <div className="section-header">
                    <div className="section-number">3</div>
                    <h3>Payment Method</h3>
                  </div>
                  <div className="section-content">
                    <div className="payment-options">
                      <div className="payment-option active">
                        <input type="radio" name="payment-method" id="credit-card" _value="" />
                        <label htmlFor="credit-card">
                          <span className="payment-icon"><i className="bi bi-credit-card-2-front"></i></span>
                          <span className="payment-label">Credit / Debit Card</span>
                        </label>
                      </div>
                      <div className="payment-option">
                        <input type="radio" name="payment-method" id="paypal" />
                        <label htmlFor="paypal">
                          <span className="payment-icon"><i className="bi bi-paypal"></i></span>
                          <span className="payment-label">PayPal</span>
                        </label>
                      </div>
                      <div className="payment-option">
                        <input type="radio" name="payment-method" id="apple-pay" />
                        <label htmlFor="apple-pay">
                          <span className="payment-icon"><i className="bi bi-apple"></i></span>
                          <span className="payment-label">Apple Pay</span>
                        </label>
                      </div>
                    </div>

                    <div className="payment-details" id="credit-card-details">
                      <div className="form-group">
                        <label htmlFor="card-number">Card Number</label>
                        <div className="card-number-wrapper">
                          <input type="text" className="form-control" name="card-number" id="card-number" placeholder="1234 5678 9012 3456" required="" />
                          <div className="card-icons">
                            <i className="bi bi-credit-card-2-front"></i>
                            <i className="bi bi-credit-card"></i>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 form-group">
                          <label htmlFor="expiry">Expiration Date</label>
                          <input type="text" className="form-control" name="expiry" id="expiry" placeholder="MM/YY" required="" />
                        </div>
                        <div className="col-md-6 form-group">
                          <label htmlFor="cvv">Security Code (CVV)</label>
                          <div className="cvv-wrapper">
                            <input type="text" className="form-control" name="cvv" id="cvv" placeholder="123" required="" />
                            <span className="cvv-hint" data-bs-toggle="tooltip" data-bs-placement="top" title="3-digit code on the back of your card">
                              <i className="bi bi-question-circle"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="card-name">Name on Card</label>
                        <input type="text" className="form-control" name="card-name" id="card-name" placeholder="John Doe" required="" />
                      </div>
                    </div>

                    <div className="payment-details d-none" id="paypal-details">
                      <p className="payment-info">You will be redirected to PayPal to complete your purchase securely.</p>
                    </div>

                    <div className="payment-details d-none" id="apple-pay-details">
                      <p className="payment-info">You will be prompted to authorize payment with Apple Pay.</p>
                    </div>
                  </div>
                </div>

                {/* <!-- Order Review --> */}
                <div className="checkout-section" id="order-review">
                  <div className="section-header">
                    <div className="section-number">4</div>
                    <h3>Review &amp; Place Order</h3>
                  </div>
                  <div className="section-content">
                    <div className="form-check terms-check">
                      <input className="form-check-input" type="checkbox" id="terms" name="terms" required="" />
                      <label className="form-check-label" htmlFor="terms">
                        I agree to the <a href="#" data-bs-toggle="modal" data-bs-target="#termsModal">Terms and Conditions</a> and <a href="#" data-bs-toggle="modal" data-bs-target="#privacyModal">Privacy Policy</a>
                      </label>
                    </div>
                    <div className="success-message d-none">Your order has been placed successfully! Thank you for your purchase.</div>
                    <div className="place-order-container">
                      <button type="submit" className="btn btn-primary place-order-btn">
                        <span className="btn-text">Place Order</span>
                        <span className="btn-price">$240.96</span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="col-lg-5">
            {/* <!-- Order Summary --> */}
            <div className="order-summary" data-aos="fade-left" data-aos-delay="200">
              <div className="order-summary-header">
                <h3>Order Summary</h3>
                <span className="item-count">2 Items</span>
              </div>

              <div className="order-summary-content">
                <div className="order-items">
                  <div className="order-item">
                    <div className="order-item-image">
                      <img src="assets/img/product/product-1.webp" alt="Product" className="img-fluid" />
                    </div>
                    <div className="order-item-details">
                      <h4>Lorem Ipsum Dolor</h4>
                      <p className="order-item-variant">Color: Black | Size: M</p>
                      <div className="order-item-price">
                        <span className="quantity">1 ×</span>
                        <span className="price">$89.99</span>
                      </div>
                    </div>
                  </div>

                  <div className="order-item">
                    <div className="order-item-image">
                      <img src="assets/img/product/product-2.webp" alt="Product" className="img-fluid" />
                    </div>
                    <div className="order-item-details">
                      <h4>Sit Amet Consectetur</h4>
                      <p className="order-item-variant">Color: White | Size: L</p>
                      <div className="order-item-price">
                        <span className="quantity">2 ×</span>
                        <span className="price">$59.99</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="promo-code">
                  <div className="input-group">
                    <input type="text" className="form-control" placeholder="Promo Code" aria-label="Promo Code" />
                    <button className="btn btn-outline-primary" type="button">Apply</button>
                  </div>
                </div>

                <div className="order-totals">
                  <div className="order-subtotal d-flex justify-content-between">
                    <span>Subtotal</span>
                    <span>$209.97</span>
                  </div>
                  <div className="order-shipping d-flex justify-content-between">
                    <span>Shipping</span>
                    <span>$9.99</span>
                  </div>
                  <div className="order-tax d-flex justify-content-between">
                    <span>Tax</span>
                    <span>$21.00</span>
                  </div>
                  <div className="order-total d-flex justify-content-between">
                    <span>Total</span>
                    <span>$240.96</span>
                  </div>
                </div>

                <div className="secure-checkout">
                  <div className="secure-checkout-header">
                    <i className="bi bi-shield-lock"></i>
                    <span>Secure Checkout</span>
                  </div>
                  <div className="payment-icons">
                    <i className="bi bi-credit-card-2-front"></i>
                    <i className="bi bi-credit-card"></i>
                    <i className="bi bi-paypal"></i>
                    <i className="bi bi-apple"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Terms and Privacy Modals --> */}
        <div className="modal fade" id="termsModal" tabIndex="-1" aria-labelledby="termsModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="termsModalLabel">Terms and Conditions</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam in dui mauris. Vivamus hendrerit arcu sed erat molestie vehicula. Sed auctor neque eu tellus rhoncus ut eleifend nibh porttitor. Ut in nulla enim. Phasellus molestie magna non est bibendum non venenatis nisl tempor.</p>
                <p>Suspendisse in orci enim. Vivamus hendrerit arcu sed erat molestie vehicula. Sed auctor neque eu tellus rhoncus ut eleifend nibh porttitor. Ut in nulla enim. Phasellus molestie magna non est bibendum non venenatis nisl tempor.</p>
                <p>Suspendisse in orci enim. Vivamus hendrerit arcu sed erat molestie vehicula. Sed auctor neque eu tellus rhoncus ut eleifend nibh porttitor. Ut in nulla enim. Phasellus molestie magna non est bibendum non venenatis nisl tempor.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" data-bs-dismiss="modal">I Understand</button>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="privacyModal" tabIndex="-1" aria-labelledby="privacyModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="privacyModalLabel">Privacy Policy</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam in dui mauris. Vivamus hendrerit arcu sed erat molestie vehicula. Sed auctor neque eu tellus rhoncus ut eleifend nibh porttitor. Ut in nulla enim.</p>
                <p>Suspendisse in orci enim. Vivamus hendrerit arcu sed erat molestie vehicula. Sed auctor neque eu tellus rhoncus ut eleifend nibh porttitor. Ut in nulla enim. Phasellus molestie magna non est bibendum non venenatis nisl tempor.</p>
                <p>Suspendisse in orci enim. Vivamus hendrerit arcu sed erat molestie vehicula. Sed auctor neque eu tellus rhoncus ut eleifend nibh porttitor. Ut in nulla enim. Phasellus molestie magna non est bibendum non venenatis nisl tempor.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" data-bs-dismiss="modal">I Understand</button>
              </div>
            </div>
          </div>
        </div>

      </div>

    </section>{/* <!-- /Checkout Section --> */}


    </Layout>

}